import { render, staticRenderFns } from "./ChallengeForumTopicForm.vue?vue&type=template&id=361eee32&scoped=true"
import script from "./ChallengeForumTopicForm.vue?vue&type=script&lang=ts"
export * from "./ChallengeForumTopicForm.vue?vue&type=script&lang=ts"
import style0 from "./ChallengeForumTopicForm.vue?vue&type=style&index=0&id=361eee32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361eee32",
  null
  
)

export default component.exports